import React, { useState } from 'react';
import './App.scss';
import * as wns from 'wns';

function App() {
  const [playing, setPlaying] = useState();
  const onClick = () => {
    setPlaying(true);
    wns.WNS({
      samplePath: "samples/"
    });
  };

  return (
    <div className={`App ${playing ? 'playing' : ''}`}>
      <div className="playButton" onClick={onClick}></div>
    </div>
  );
}

export default App;
